import { defineMessages } from 'react-intl';

export default defineMessages({
    condominiumUsedAs: {
        id: 'tfpa.policyChange.views.messages.CondominiumUsedas',
        defaultMessage: 'Condominium Used as'
    },
    dwellingUsedAs: {
        id: 'tfpa.policyChange.views.messages.DwellingUsedas',
        defaultMessage: 'Dwelling Used as'
    },
    homeUsedAs: {
        id: 'tfpa.policyChange.views.messages.HomeUsedas',
        defaultMessage: 'Home Used as'
    },
    condominiumOccupancy: {
        id: 'tfpa.policyChange.views.messages.condominiumOccupancy',
        defaultMessage: 'Condominium Occupancy'
    },
    dwellingOccupancy: {
        id: 'tfpa.policyChange.views.messages.dwellingOccupancy',
        defaultMessage: 'Dwelling Occupancy'
    },
    homeis: {
        id: 'tfpa.policyChange.views.messages.homeis',
        defaultMessage: 'Home is'
    },
    condoForSale: {
        id: 'tfpa.policyChange.views.messages.Is the condominium for sale?',
        defaultMessage: 'Is the condominium for sale?'
    },
    dwellingForSale: {
        id: 'tfpa.policyChange.views.messages.dwellingForSale',
        defaultMessage: 'Is the dwelling for sale?'
    },
    condoRenov: {
        id: 'tfpa.policyChange.views.messages.condoRenov',
        defaultMessage: 'Is the condominium undergoing renovation or reconstruction?'
    },
    dwellingRenov: {
        id: 'tfpa.policyChange.views.messages.dwellingRenov',
        defaultMessage: 'Is the dwelling undergoing renovation or reconstruction?'
    },
    dwellingFirePlace: {
        id: 'tfpa.policyChange.views.messages.dwellingFirePlace',
        defaultMessage: 'Does the dwelling have a Fireplace?'
    },
    Fireplace: {
        id: 'tfpa.policyChange.views.messages.Fireplace',
        defaultMessage: 'Fireplace'
    },
    dwellingWoodStove: {
        id: 'tfpa.policyChange.views.messages.dwellingWoodStove',
        defaultMessage: 'Does the dwelling have a Wood Stove?'
    },
    woodStove: {
        id: 'tfpa.policyChange.views.messages.woodStove',
        defaultMessage: 'Wood Stove'
    },
    atleastOneDog: {
        id: 'tfpa.policyChange.views.messages.atleastOneDog',
        defaultMessage: 'Add at least one dog or exotic pet.'
    },
    yearMessage: {
        id: 'tfpa.policyChange.views.messages.yearMessage',
        defaultMessage: 'Year built cannot be greater than current year.'
    },
    yearMessageGreater: {
        id: 'tfpa.policyChange.views.messages.yearMessageGreater',
        defaultMessage: 'Year built must be greater than 1799.'
    }
});